import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import PropTypes from 'prop-types'

function TableSkeleton({ rows = 5, columns = 3, height = 20, className }) {
  return (
    <div style={{ overflowX: 'auto' }} className={className}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, colIdx) => (
              <th key={colIdx} style={{ padding: '8px' }}>
                <Skeleton height={height} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx}>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <td key={colIdx} style={{ padding: '8px' }}>
                  <Skeleton height={height} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
}

export default TableSkeleton
